import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations } from 'vuex';
import TransitionExpand from '~/components/templates/TransitionExpand.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';
import { searchFiltersLabels } from '~/const/listing/algolia';
export default {
  name: 'CategoryFiltersBar',
  components: {
    TransitionExpand: TransitionExpand
  },
  props: {
    activeFilters: {
      type: Array,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: _objectSpread({}, mapMutations({
    filterBy: 'pageActions/FILTER_BY',
    resetFilters: 'pageActions/RESET_FILTERS'
  }), {
    removeFilter: function removeFilter(tag) {
      this.filterBy({
        filter: tag.filter,
        facet: tag.facet
      });
    },
    reset: function reset() {
      this.$emit('on-reset-filters');
      this.resetFilters();
    },
    getTagLabel: function getTagLabel(activeFilter) {
      if (activeFilter.filter === 'more_info') return searchFiltersLabels[activeFilter.label] || activeFilter.label;
      return activeFilter.filter === 'price' ? this.formatCurrency(activeFilter.label) : activeFilter.label;
    },
    activeFilterLabel: function activeFilterLabel(activeFilter) {
      return ['depth', 'width', 'height'].includes(activeFilter.filter) ? "".concat(this.$t(activeFilter.filter), ": ").concat(this.getTagLabel(activeFilter)) : this.getTagLabel(activeFilter);
    },
    formatCurrency: function formatCurrency(value) {
      var _this = this;

      var prices = value.split('-');
      var formattedPrices = [];
      prices.forEach(function (price) {
        formattedPrices.push(new Intl.NumberFormat(_this.locale.iso, {
          style: 'currency',
          currency: _this.locale.currency,
          maximumSignificantDigits: 3
        }) // eslint-disable-next-line
        .format(price));
      });
      return formattedPrices.join(' - ');
    }
  })
};